import DashboardLayout from "../../../shared/DashboardLayout";

const ViewBorrower = () => {
  return (
    <DashboardLayout>
      <h2 className="m-4">View Borrower</h2>
      <form action="" method="post">
        <div class="row m-4">
          <div class="col-lg-1">
            <label for="ac_number" class="fw-bolder">
              File#
            </label>
          </div>
          <div class="col-lg-2 form-group">
            <input
              autofocus=""
              type="text"
              value=""
              id="ac_number"
              name="ac_number"
              autocomplete="off"
              class="form-control"
            />
          </div>
          <div class="col-lg-3 form-group">
            <input
              type="text"
              value=""
              id="house_number"
              name="house_number"
              autocomplete="off"
              class="form-control"
              placeholder="House Number"
            />
          </div>
          <div class="col-lg-2">
            <input
              type="submit"
              value="Search"
              class="btn site_btn text-white"
            />
          </div>
        </div>
      </form>
      <h2 class="mx-4">No Record Found.</h2>
    </DashboardLayout>
  );
};

export default ViewBorrower;
